import {Layout} from '@di-nxt/components';
import React from 'react';

type RowProps = {
  minHeight?: number;
};

export const Row: React.FC<RowProps> = ({minHeight, children}) => {
  return (
    <Layout
      flex
      horizontal
      overflow={'hidden'}
      justify="space-evenly"
      minHeight={minHeight}>
      {children}
    </Layout>
  );
};
